import { api } from './endpoint'
import { createInstance } from './api'

const apiRoot = api('/api/v2/')

const instance = createInstance(apiRoot, 'application/json')

export const { post, put, get, patch } = instance

export const del = instance.delete
